<template>
  <el-container direction="vertical">
    <el-main>
      <el-tree
        :data="groupTreeData"
        v-if="groupTreeData.length"
        default-expand-all
        :expand-on-click-node="false"
        @node-click="
          () => {
            deleteFromApplyGroupBy(arguments[0].group_code);
          }
        "
      >
        <template slot-scope="scope">
          <div class="group-node">
            {{ scope.data.label }}
            <i class="remove-group-node el-icon-close"></i>
          </div>
        </template>
      </el-tree>
      <template v-if="group_by.length && groupTreeData.length">
        <br /><br />
      </template>
      <el-select
        :value="null"
        @change="addToApplyGroupBy"
        v-if="group_by.length"
        :placeholder="(groupTreeData.length ? 'Then g' : 'G') + 'roup by'"
      >
        <el-option v-for="(v, k) in group_by" :key="k" :label="v" :value="v" />
      </el-select>
    </el-main>
    <el-main>
      <el-tag
        v-for="tag in filter_strings"
        :key="tag"
        closable
        :disable-transitions="false"
        @close="deleteFromFilterStrings(tag)"
        >{{ tag }}</el-tag
      >
      <template v-if="filter_strings.length"> <br /><br /> </template>
      <el-input
        v-model="filter_string"
        placeholder="Type to filter the list"
        clearable
        @keyup.enter.native="addToFilterStrings"
      />
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "FilterTools",
  props: {
    value: {
      type: String
    },
    filterStrings: {
      type: Array,
      default: () => []
    },
    addToFilterStrings: {
      type: Function,
      default: () => ({})
    },
    deleteFromFilterStrings: {
      type: Function,
      default: () => ({})
    },
    deleteFromApplyGroupBy: {
      type: Function,
      default: () => []
    },
    addToApplyGroupBy: {
      type: Function,
      default: () => []
    },
    groupBy: {
      type: Array,
      default: () => []
    },
    applyGroupBy: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filter_string: this.value,
      filter_strings: this.filterStrings,
      group_by: this.groupBy,
      apply_group_by: this.applyGroupBy
    };
  },
  watch: {
    value(v) {
      this.filter_string = v;
    },
    filter_string() {
      this.$emit("input", this.filter_string);
    },
    filter_strings() {
      this.$emit("ipdate:filterStrrings", this.filter_strings);
    },
    groupBy(v) {
      this.group_by = v;
    },
    applyGroupBy(v) {
      this.apply_group_by = v;
    },
    filterStrings(v) {
      this.filter_strings = v;
    }
  },
  computed: {
    groupTreeData() {
      let t = [...this.apply_group_by];
      return t.reverse().reduce((r, v) => {
        return [
          {
            label: v,
            group_code: v,
            children: r
          }
        ];
      }, []);
    }
  }
};
</script>

<style scoped lang="stylus">
.el-container.is-vertical
    & > main
        user-select none

        &:not(:last-child)
            margin-bottom 5px

.group-node
    display flex
    justify-content space-between
    align-items center
    width 100%

    & .remove-group-node
        display none
        color red
        font-weight bold

.el-tree-node__content:hover
    & .remove-group-node
        display inline-block
</style>
